// shell/components/entity-fields/view-renderers/text-renderer.ts

import { createElement } from '../../../utils/dom';
import type { TextViewField } from '../../entity-view/types';

/**
 * Renders a text field value with optional formatting.
 */
export function renderTextView<T>(
    field: TextViewField<T>,
    value: unknown,
    model: T
): HTMLElement {
    const container = createElement('div', {
        className: 'ev-field-view ev-field-view--text',
    });

    let displayValue = '';
    if (value !== null && value !== undefined) {
        displayValue = String(value);
        if (field.format) {
            displayValue = field.format(displayValue, model);
        }
    }

    if (displayValue) {
        container.textContent = displayValue;
    } else {
        container.classList.add('ev-field-view--empty');
        container.textContent = '—';
    }

    return container;
}
